import global from '../../global.js';
import Api from '../api';
import {
	Message,
	MessageBox,
	Loading
} from 'element-ui';
import VUE from 'vue';

export default {
	install(Vue, options) {
		//全局配置信息
		Vue.prototype.GLOBAL = global;


		//所有api借口
		Vue.prototype.$api = Api;


		//提示信息封装
		const alert = (message, duration = 1000, type = "success") => new Promise((resolve, reject) => {
			Message({
				message,
				duration,
				type
			});
			setTimeout(() => {
				resolve();
			}, duration);
		});
		Vue.prototype.alert = (message, duration = 1000) => alert(message, duration, "success");
		Vue.prototype.alertSuccess = (message, duration = 1000) => alert(message, duration, "success");
		Vue.prototype.alertWarning = (message, duration = 1000) => alert(message, duration, "warning");
		Vue.prototype.alertError = (message, duration = 1000) => alert(message, duration, "error");


		//确认框
		Vue.prototype.confirm = (message) => MessageBox({
			message,
			title: "提示",
			type: "warning",
			showCancelButton: true,
			closeOnClickModal: false
		});


		// 展示和隐藏Loading组件
		let loadingInstance;
		Vue.prototype.beginLoad = (ops) => {
			var defaults = {
				body: true,
				lock: false,
				text: "拼命加载中",
				fullscreen: true,
				background: "transparent",
				// spinner: "el-icon-loading",
				spinner: "el-icon-refresh",
				target: "body",
				customClass: "myLoading"
			};
			// el-icon-refresh
			defaults = Object.assign(defaults, ops);
			defaults.target = document.querySelector(defaults.target);
			loadingInstance = Loading.service(defaults);

		}
		Vue.prototype.endLoad = () => {
			if (loadingInstance != undefined) {
				loadingInstance.close();
			}
		}


		// 克隆对象
		Vue.prototype.clone = (obj) => {
			return clone(obj);
		}


		// 获取data某属性
		Vue.prototype.data = function(key) {
			return this.clone(this[key]);
		}


		//事件总线
		var EventBus = new VUE();
		Vue.prototype.$bus = EventBus;

		Vue.prototype.download = function(api, fileName) {
			return new Promise((resolve, reject) => {
				api.then(t => {
					resolve();
					var blob = new Blob([t]);
					var url = window.URL.createObjectURL(blob);
					var aLink = document.createElement("a");
					aLink.style.display = "none";
					aLink.href = url;
					aLink.setAttribute("download", `${fileName}.xls`);
					document.body.appendChild(aLink);
					aLink.click();
					document.body.removeChild(aLink); //下载完成移除元素
					window.URL.revokeObjectURL(url); //释放掉blob对象
				}).catch(reject);
			});
		}


		// 仿小程序开发赋值
		Vue.prototype.setData = function(obj) {
			for (let key in obj) {
				let value = obj[key];
				//1：直接赋值：无[]，无.
				if (key.indexOf("[") == -1 && key.indexOf(".") == -1) {
					this[key] = value;
				}
				//2：数组结尾：]结尾
				else if (key.EndWith("]")) {
					let index = key.lastIndexOf("[");
					let prop = key.substring(index + 1, key.length - 1)
					let preKey = key.substring(0, key.length - prop.length - 2);
					eval(`this.${preKey}.splice(${parseInt(prop)},1,${value})`);
				}
				//3：包含.：包含.并且以字符串结尾
				else {
					let index = key.lastIndexOf(".");
					let prop = key.substring(index + 1, key.length)
					if (typeof value == 'string') {
						eval(
							`this.$set(this.${key.substring(0, key.length - prop.length - 1)}, '${prop}', '${value}');`);
					} else {
						eval(
						`this.$set(this.${key.substring(0, key.length - prop.length - 1)}, '${prop}', value);`);
					}
				}
			}
		}
	}
};



function clone(obj, hash = new WeakMap()) {
	// 解决循环引用
	if (hash.has(obj)) {
		return hash.get(obj)
	}
	let temp = null;
	if (obj instanceof Array) {
		// 特殊处理数组对象类型
		temp = []
		hash.set(obj, temp)
		obj.forEach(item => {
			temp.push(clone(item, hash));
		})
	} else if (obj instanceof RegExp) {
		// 特殊处理正则对象类型
		const {
			source,
			global,
			ignoreCase,
			multiline
		} = obj;
		let flags = '';
		if (global) flags += 'g';
		if (ignoreCase) flags += 'i';
		if (multiline) flags += 'm';
		temp = new RegExp(source, flags);
	} else if (obj instanceof Date) {
		// 特殊处理时间对象类型
		temp = new Date(obj.getTime());
	} else if (typeof obj === 'object') {
		// 处理普通对象类型
		// 以obj的原型为原型，构造一个新对象
		temp = Object.create(obj.__proto__);
		hash.set(obj, temp)
	} else {
		temp = obj;
	}
	// 任何对象类型，都遍历递归自身的属性
	if (typeof obj === 'object') {
		for (let [key, val] of Object.entries(obj)) {
			temp[key] = clone(val, hash);
		}
	}
	return temp;
}
